import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeEN from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { TranslateLoader } from '@ngx-translate/core';

import { CamCapacitorModule, CamPwaService, PWA_CONFIG_KEY } from '@camelot/capacitor';
import { provideGoogleMaps } from '@camelot/core';
import { NotificationBoxComponent, provideNotification } from '@camelot/notification';
import { STRAPI_SERVER_CONFIG } from '@camelot/server';
import { CamServerModule, GRAPHQL_SERVER_CONFIG, SERVER_CONFIG_KEY } from '@camelot/server';
import { E2eTranslationLoader, provideHarnessCases } from '@camelot/testing-harness';
import { TRANSLATION_CONFIG, TranslatePipe, provideTranslation } from '@camelot/translation';
import { PwaComponent } from '@camelot/ui';
import { provideAuth0, provideUser } from '@camelot/user';
import { APPLICATION_CONFIG, LOCAL } from '@camelot/utils';

import { E2E_CASES } from '../../e2e/cases';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppBaseModule } from './features/base/base.module';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEN, 'en');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppBaseModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CamCapacitorModule, // only for PWA/APP
    NotificationBoxComponent,
    PwaComponent,
    CamServerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.PWAACTIVE,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    HttpClientModule,
    TranslatePipe,
  ],
  providers: [
    provideTranslation({
      default: environment.TRANSLATION.DEFAULT,
      supportedLanguages: environment.TRANSLATION.SUPPORTEDLANGUAGES,
    }),
    provideAuth0({ config: environment.AUTH0 }),
    provideUser(),
    provideGoogleMaps(),
    provideNotification({ canDisplayErrorDetails: !environment.production }),
    provideHarnessCases(E2E_CASES),
    { provide: TranslateLoader, useClass: E2eTranslationLoader },
    {
      provide: PWA_CONFIG_KEY,
      useValue: { active: environment.PWAACTIVE },
    },
    {
      provide: SERVER_CONFIG_KEY,
      useValue: {
        pendindRequestId: environment.PENDINGREQUESTAPI,
        serverUrl: environment.SERVER_URL,
      },
    },
    {
      provide: LOCAL,
      useValue: { isLocal: environment.LOCAL },
    },
    {
      provide: APPLICATION_CONFIG,
      useValue: { isCustomerApplication: environment.IS_CUSTOMER_APPLICATION },
    },
    {
      provide: GRAPHQL_SERVER_CONFIG,
      useValue: { config: environment.GRAPHQL_SERVER_CONFIG },
    },
    {
      provide: STRAPI_SERVER_CONFIG,
      useValue: { config: environment.STRAPI_SERVER_CONFIG },
    },
    {
      provide: TRANSLATION_CONFIG,
      useValue: {
        default: environment.TRANSLATION.DEFAULT,
        supportedLanguages: environment.TRANSLATION.SUPPORTEDLANGUAGES,
      },
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    CamPwaService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
